import i18n from '@/lang/i18n'

export default function() {
    return [
        { type: 'customCheckbox' },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.externalCode'),
            colId: 'code',
            field: 'code',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.tc('configuration.sections.countries', 1),
            colId: 'name',
            field: 'name',
            flex: 1
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.t('configuration.grid.active'),
            colId: 'active',
            field: 'active',
            flex: 1
        }
    ]
}
